import useFlag from 'hooks/useFlag'
import { useSelector } from 'react-redux'
import { selectCurrentMerchantUser } from 'selectors/merchantUser'

export const useRoleLocationScope = () => {
  const rbacEnabled = useFlag('role-based-access-control', false)
  const currentUser = useSelector(selectCurrentMerchantUser)

  if (!rbacEnabled || !currentUser) {
    return { isGlobal: true, locationIds: [] as number[] }
  }

  const locationIds: number[] = currentUser.location_ids ?? []
  return {
    isGlobal: locationIds.length === 0,
    locationIds,
  }
}
